import React from 'react';
import { CheckCircle, FileText, Receipt } from 'lucide-react';
import './documentoPago.css';

export type DocumentoPago = 'factura' | 'prefactura';

export default function DocumentoPagoSelector({value, onChange, disabled, destino}: {
  value: DocumentoPago; onChange: (value: DocumentoPago) => void; disabled?: boolean; destino: string;
}) {
  return <fieldset disabled={disabled} className="payment-document">
    <legend>¿Qué documento necesita el cliente?</legend>
    <div className="payment-document-options">
      {(['factura', 'prefactura'] as const).map(tipo => <label key={tipo} className={`payment-document-option ${tipo}`}>
        <input type="radio" name={`documento-${destino}`} aria-label={tipo === 'factura' ? 'Factura' : 'Prefactura'}
          checked={value === tipo} onChange={() => onChange(tipo)} />
        <span className="payment-document-card"><span className="payment-document-icon">{tipo === 'factura' ? <Receipt size={21} /> : <FileText size={21} />}</span>
          <span><strong>{tipo === 'factura' ? 'Factura' : 'Prefactura'}</strong><span className="payment-document-description">{tipo === 'factura'
          ? 'Cobrar el saldo completo y emitir factura' : 'Recibo con opción de facturar después'}</span></span><CheckCircle size={17} className="payment-document-check" />
        </span>
      </label>)}
    </div>
  </fieldset>;
}
